<template>
	<table class="grid simple">
		<thead>
			<tr>
				<th :style="columnStyle">
					<div class="bar bg-blue rider">
						<h3>Rider</h3>
					</div>
				</th>
				<th v-for="lot in board.totalLots" :key="lot" :style="columnStyle">
					<div class="bar bg-brown lot">
						<h3>Lot {{ lot }}</h3>
					</div>
				</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="row in board.totalRows" :key="row" :style="rowStyle(row)">
				<template v-if="showRow(row)">
					<td>
						<Person v-if="board.rows[row] && board.rows[row].person" :person="peopleById[board.rows[row].person]"/>
					</td>
					<td v-for="lot in board.totalLots" :key="lot">
						<Horse v-if="board.rows[row] && board.rows[row].lots[lot] && horsesById[board.rows[row].lots[lot]]" :horse="horsesById[board.rows[row].lots[lot]]" :tasks="board.tasks[board.rows[row].lots[lot]]"/>
					</td>
				</template>
			</tr>
		</tbody>
	</table>
</template>

<script>
import { mapState } from 'vuex'
import { Container, Draggable } from 'vue-smooth-dnd'
import Horse from '../../Common/Horse.vue'
import Person from '../../Common/Person.vue'

export default {
	props: ['board', 'locationFilter', 'split', 'splitPosition'],
	components: {
		Container,
		Draggable,
		Horse,
		Person
	},
	computed : {
		...mapState({
			people: state => state.people.list,
			horseList: state => state.horses.list,
			lots: state => state.lots.list
		}),
		peopleById() {
			return this.mapArrayById(this.$store.getters['people/list'], 'id')
		},
		horsesById() {
			return this.mapArrayById(this.horses, 'id')
		},
		columnStyle() {
			const columnWidth = 100 / (this.board.totalLots + 1)

			return {
				width: columnWidth + '%'
			}
		},
		visibleRows() {
			return this.board.totalRows > 19 ? 1 : 20 - this.board.totalRows 
		},
		horses() {
			return this.horseList.filter(horse => {
				return this.locationFilter.id === 0 || horse.location_id === this.locationFilter.id	
			})
		}
	},
	methods: {
		showRow(row) {
			if(this.split) {
				const n = this.splitPosition - 1

				return Math.abs(row % 2) !== n && this.rowHasHorse(row)
			} else {
				return this.rowHasHorse(row)
			}
		},
		rowStyle(row) {
			if(!this.showRow(row)) {
				return {
					display: 'none'
				}
			} else {
				return {}
			}
		},
		rowHasHorse(row) {
			if(this.locationFilter.id === 0) {
				return true
			}
			for(let lot = 1;lot<=this.lots.length;lot++) {
				if(this.board.rows[row] && this.board.rows[row].lots[lot] && this.horsesById[this.board.rows[row].lots[lot]]) {
					return true
				}
			}
			return false
		}
	}
}
</script>

<style lang="scss">
.grid.simple {
	th {
		h3 {
			margin-top: 3px;
		}
	}
	.bar.horse {
		.tasks button {
			display: none;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Board/Grids/Simple.vue